
<h1 mat-dialog-title>{{sharedDataContent.users_list.title}}</h1>
<div mat-dialog-content>
  <div class="customer-list">
    <mat-list>
      <mat-list-item class="customer-list-header">
        <span>{{sharedDataContent.users_list.user_name}}</span>
        <span>{{sharedDataContent.users_list.user_email}}</span>
        <span>{{sharedDataContent.users_list.status}}</span>
      </mat-list-item>
      @for (customer of data; track customer) {
        <mat-list-item class="customer-list-body">
          <span>{{customer.userName}}</span>
          <span>{{customer.userEmail}}</span>
          <span>{{customer.status}}</span>
        </mat-list-item>
      }
    </mat-list>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close cdkFocusInitial>{{sharedDataContent.buttons_list.ok}}</button>
</div>